<div class="white-box">
  <h3 class="ui-headline">{{ 'profile.language.p' | translate }}</h3>
  <form [formGroup]="formLang" class="languages">
    <div class="languages-item" *ngFor="let lang of languages">
      <input
        [id]="'radio-' + lang.code"
        type="radio"
        formControlName="language"
        class="form-radio"
        [value]="lang.code"
        [checked]="formLang.controls.language.value === lang.code"
      />
      <label [for]="'radio-' + lang.code" class="radio-label"> {{ lang.fullName }} </label>
    </div>
  </form>
  <button (click)="changeLanguage()" class="ui-button">
    {{ 'save_changes' | translate }}
  </button>
</div>
